import { ApiEndpointHandler, createPostEndpoint, SuccessStatusCode } from '@sonar-software/sonar-http';

export type PostInitiativeSonarObjectsRequest = {
	initiativeId: number;
	initiativeTitle: string;
	sonarObjectIds: Array<number>;
};

export type PostInitiativeSonarObjectsResponse = {
	initiativeId: number;
	initiativeTitle: string;
};

const postInitiativeSonarObjectsBase = createPostEndpoint<
	PostInitiativeSonarObjectsRequest,
	PostInitiativeSonarObjectsResponse
>(({ initiativeId }) => `/api/v3/initiatives/${initiativeId}/add-sonarobjects`, {
	requestTransform: ({ sonarObjectIds }) => ({ sonarObjectIds })
});

export const postInitiativeSonarObjects: ApiEndpointHandler<
	PostInitiativeSonarObjectsRequest,
	PostInitiativeSonarObjectsResponse
> = async(request, options) => {
	const result = await postInitiativeSonarObjectsBase(request, options);

	if (result && result.status === SuccessStatusCode.NoContent) {
		result.data = {
			initiativeId: request.initiativeId,
			initiativeTitle: request.initiativeTitle
		};
	}

	return result;
};
